export const getDocumentElement = (
  container?: HTMLElement
): {
  clientWidth: number
  clientHeight: number
  scrollLeft: number
  scrollTop: number
} => {
  if (document.documentElement.clientHeight) {
    return container || document.documentElement
  }
  return {
    clientWidth: 1920,
    clientHeight: 1080,
    scrollLeft: 0,
    scrollTop: 0,
  }
}
